var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutalerticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 73,
    viewBox: "0 0 70 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0006 10.3417C21.1686 10.3417 9.91666 22.076 9.91666 36.5001C9.91666 50.9239 21.1686 62.6583 35.0006 62.6583C48.8314 62.6583 60.0832 50.9239 60.0832 36.5001C60.0833 22.076 48.8314 10.3417 35.0006 10.3417ZM39.6667 54.1189C39.6667 54.971 39.0038 55.6624 38.1856 55.6624H31.8144C30.9961 55.6624 30.3332 54.9709 30.3332 54.1189V34.2412C30.3332 33.3893 30.996 32.6978 31.8144 32.6978H38.1856C39.0038 32.6978 39.6667 33.3893 39.6667 34.2412V54.1189ZM35.0006 26.7667C31.8603 26.7667 29.3125 24.1112 29.3125 20.8352C29.3125 17.5597 31.8602 14.9041 35.0006 14.9041C38.1398 14.9041 40.6874 17.5597 40.6874 20.8352C40.6874 24.1112 38.1398 26.7667 35.0006 26.7667Z",
    fill: "#244DA0",
    fillOpacity: 0.479167
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0004 0C15.6709 0 0 16.342 0 36.5001C0 56.658 15.6709 73 35.0004 73C54.3299 73 69.9997 56.658 69.9997 36.5001C69.9997 16.342 54.3301 0 35.0004 0ZM35.0004 67.525C18.5955 67.525 5.25071 53.6071 5.25071 36.5003C5.25071 19.3929 18.5955 5.475 35.0004 5.475C51.404 5.475 64.7503 19.3929 64.7503 36.5003C64.7503 53.6071 51.404 67.525 35.0004 67.525Z",
    fill: "#244DA0",
    fillOpacity: 0.479167
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 73,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutalerticon);
export default __webpack_public_path__ + "static/media/logoutalerticon.020dc3bebe8992c4866e7e1edc8dc24c.svg";
export { ForwardRef as ReactComponent };